import React from 'react';
import './ConfirmPopup.scss';
import { useTranslation } from '../contexts/TranslationContext';

const ConfirmPopup = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation()

  if (!isOpen) return null;
  return (
    <div className="confirm-popup-overlay">
      <div className="confirm-popup">
        <p>{t("you_sure")}</p>
        <div className="confirm-popup-buttons">
          <button className="confirm-popup-button yes-button" onClick={onConfirm}>{t("yes")}</button>
          <button className="confirm-popup-button no-button" onClick={onCancel}>{t("no")}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
